<script lang="ts">
  /**
   * Vista cuando el take-over activo es HDMI_INPUT.
   *
   * En realidad, en una Tizen real, deberíamos invocar la Tizen TVAPI para
   * cambiar el input físicamente:
   *
   *   webapis.avplay?.stop();
   *   tizen.tvinputdevice.setSource(...)
   *
   * Eso hace que el TV deje de mostrar la web app y pase al HDMI.
   * Mientras la app sigue corriendo en background. Cuando se acaba el takeover,
   * cambiamos de nuevo el input al "PC" o "URL Launcher" y la web vuelve.
   *
   * En esta vista mostramos un splash mientras se cambia el input.
   */
  export let input: 'HDMI1' | 'HDMI2' | 'HDMI3';

  // TODO: integración real con Tizen TVAPI cuando esté disponible
</script>

<div class="hdmi">
  <div class="logo">📺</div>
  <div class="title">Modo {input}</div>
  <div class="hint">Cambiando entrada de video…</div>
</div>

<style>
  .hdmi {
    position: absolute;
    inset: 0;
    background: #000;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
  }
  .logo {
    font-size: 8rem;
  }
  .title {
    font-size: 4rem;
    font-weight: 700;
    letter-spacing: 0.05em;
  }
  .hint {
    font-size: 1.5rem;
    opacity: 0.6;
  }
</style>
